export default __webpack_public_path__ + "static/media/prev-E1A-TOP.ac63a4ff.png";